import React, { useEffect } from 'react';
import { HashRouter as Router, Route, Routes, NavLink } from 'react-router-dom';
import ProjectOverview from './pages/ProjectOverview';
import ShootingStandards from './pages/ShootingStandards';
import TaskManager from './pages/TaskManager';
import { initSampleData } from './utils/taskStorage';
import './App.css';

function App() {
  useEffect(() => {
    // 初始化示例数据
    initSampleData();
  }, []);

  return (
    <Router>
      <div className="app">
        {/* 顶部导航 */}
        <header className="app-header">
          <div className="header-inner">
            <div className="brand">
              <span className="brand-logo"><img src="/logo.png" alt="Prolockey" /></span>
              <span className="brand-sep">|</span>
              <span className="brand-sub">视频拍摄任务管理</span>
            </div>
            
            <nav className="main-nav">
              <NavLink 
                to="/" 
                className={({isActive}) => `nav-link ${isActive ? 'active' : ''}`}
                end
              >
                <span className="nav-icon">🏠</span>
                项目说明
              </NavLink>
              <NavLink 
                to="/standards" 
                className={({isActive}) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <span className="nav-icon">📋</span>
                拍摄标准
              </NavLink>
              <NavLink 
                to="/tasks" 
                className={({isActive}) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <span className="nav-icon">✅</span>
                任务管理
                <span className="nav-badge">核心</span>
              </NavLink>
            </nav>

            <div className="header-info">
              <span className="info-tag">内部工具</span>
            </div>
          </div>
        </header>

        {/* 主内容区 */}
        <main className="app-main">
          <Routes>
            <Route path="/" element={<ProjectOverview />} />
            <Route path="/standards" element={<ShootingStandards />} />
            <Route path="/tasks" element={<TaskManager />} />
          </Routes>
        </main>

        {/* 页脚 */}
        <footer className="app-footer">
          <p>© 2026 Prolockey 洛科安全防护用品有限公司 · 内部使用</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
